const users = {
  users: {
    pageHeader: 'Utente',
    addNewUser: '+ Aggiungi nuovo utente',
    name: 'Nome',
    role: 'Ruolo',
    company: 'Azienda',
    status: 'Stato',
    noUser: '** Nessun utente disponibile **',
    emailMatch: 'Inserire nuovamente lo stesso valore.',
    validEmail: 'Inserire un indirizzo e-mail valido.',
    fieldRequired: 'Questo campo è obbligatorio.',
    userFormHeader: 'Aggiungi nuovi utenti',
    userProfile: 'Profilo utente',
    defaultEmailHelpText: 'A questo indirizzo verrà inviata una e-mail con la spiegazione su come registrarsi.',
    active: 'Attivo',
    email: 'E-mail',
    confirmEmail: 'E-mail di conferma',
    firstName: 'Nome',
    lastName: 'Nome di battesimo',
    phoneNumber: 'Numero di telefono',
    preferredLocale: 'Impostazione locale preferita',
    units: 'Unità',
    addUser: 'Aggiungi utente',
    updateUser: 'Aggiorna utente',
    supportTechnician: `Addetto all'assistenza`,
    profileAdministrator: 'Amministratore profili',
    profileApprover: 'Approvatore profili',
    administrator: 'Amministratore',
    user: 'Utente',
    viewOnly: 'Solo visualizzazione',
    demonstration: 'Dimostrazione',
    errorMessageLengthPhone: 'Sono consentiti un massimo di 50 caratteri',
    all: 'Tutti',
    inactive: 'Inattivo',
    termsAndServices: "Solo il proprietario del sistema può fornire l'accesso al proprio sito.Senza l'approvazione scritta del proprietario del sistema, gli installatori non possono fornire l'accesso ad altre società e non possono fornire l'accesso agli utenti al di fuori della propria azienda. Ho letto e accetto le %{termsService} di Enphase e ho letto l'%{privacyPolicy} di Enphase.Comprendo che la violazione di queste condizioni può comportare la sospensione o la chiusura del mio account Enlighten.",
    privacyPolicy: 'Informativa sulla privacy',
    termsService: 'Condizioni del servizio',
  }
};

export default users;
